import { render, staticRenderFns } from "./entry-categories.vue?vue&type=template&id=abd73bac&scoped=true&"
import script from "./entry-categories.vue?vue&type=script&lang=ts&"
export * from "./entry-categories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd73bac",
  null
  
)

export default component.exports